export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      '[data-autoreconciliation-import-running="true"]'
    ) as HTMLElement

    if (element) {
      const channelName = element.dataset.autoreconciliationChannelName
      const messagebusLastId = parseInt(
        element.dataset.messagebusLastId as string
      )

      if (channelName) {
        window.Silverfin.Polling.subscribe(
          channelName,
          () => {
            window.Turbolinks.visit(window.location.pathname)
          },
          messagebusLastId
        )
      }
    }
  })
}
